import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {UiContainerSpalte} from '../../../models/uiContainerSpalte';
import {UiVorgang} from '../../../models/uiVorgang';
import {UIArtefaktTyp} from '../../../models/uiArtefaktTyp';
import {UIArtefakt, UIContainerControl} from '../../../models/uiArtefakt';

@Component({
    selector: 'lv-ui-spalte',
    templateUrl: './ui-spalte.component.html',
    styleUrls: ['./ui-spalte.component.scss'],
    standalone: false
})
export class UiSpalteComponent implements OnChanges {

  @Input()
  public uiSpalte: UiContainerSpalte;

  @Input()
  public uiVorgang: UiVorgang;

  public uiArtefakte: UIArtefakt[];

  constructor() {
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const artefakte = this.uiVorgang.UIArtefakt.filter(artefakt => artefakt.UIArtefakttyp === UIArtefaktTyp.UI_CONTAINER)
    .filter(artefakt => (artefakt as UIContainerControl).UIContainerComponent === this.uiSpalte);
    this.uiArtefakte = artefakte[0]?.UIArtefakt;
  }

}
